import { useEffect, useState } from "react";

export function useTheme() {
  const [theme, _setTheme] = useState(() => localStorage.getItem("theme") || "system");

  useEffect(() => {
    const root = document.documentElement;
    const systemDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    const enableDark = theme === "dark" || (theme === "system" && systemDark);
    root.classList.toggle("dark", enableDark);
  }, [theme]);

  useEffect(() => {
    if (theme !== "system") return;
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const onChange = (e) => document.documentElement.classList.toggle("dark", e.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [theme]);

  const setTheme = (next) => {
    _setTheme(next);
    localStorage.setItem("theme", next);
  };

  return { theme, setTheme };
}
